define([
    'i18next'
    // 'hbs/handlebars'
], function (
    i18n
    // Handlebars
    ) {
    function toi18n (key, args) {
        if(args && args.hash && args.hash.keySuffix) {
            key = `${key}.${args.hash.keySuffix}`;
        }
        return i18n.t(key, args);
    }

    // Handlebars.registerHelper('i18n', toi18n);
    return toi18n;
});



// WEBPACK FOOTER //
// ./common/ui/template/helper/i18n.js